import { Chip, ChipProps } from '@mui/material'

import { B2CState } from '../../../@types/b2c.types.ts'
import { EMPTY_VALUE } from '../../../constants.ts'

interface B2CStateRendererProps {
  value: B2CState
}

const STATUS_COLORS: Record<B2CState, ChipProps['color']> = {
  NEW: 'warning',
  PAID: 'success',
  REJECTED: 'error',
  PROCESSING: 'warning',
}

const STATUS_TITLES: Record<B2CState, string> = {
  NEW: 'Запрос к получателю',
  PAID: 'Успешно',
  REJECTED: 'Неуспешно',
  PROCESSING: 'В работе',
}

export const B2CStateRenderer = ({ value }: B2CStateRendererProps) => {
  return value ? (
    <Chip
      label={STATUS_TITLES[value]}
      color={STATUS_COLORS[value]}
      variant="filled"
      size="small"
      sx={{
        borderRadius: 2,
      }}
    />
  ) : (
    EMPTY_VALUE
  )
}
